import {apiHost} from '../../util';
import {apiClient} from '../../../util/api-client';
import {BaseClient} from '../utils/base-client';
import Cohort from 'common/widgets/cohorts-query-builder/models/cohort';

export interface CohortParams {
  name: string;
  description: string;
  is_visible: boolean;
  is_locked: boolean;
  selector: object;
  behaviors: object;
  data_group_id?: number;
}

interface CohortResponse {
  id: number;
  name: string;
  description: string;
  selector: object;
  behaviors: object;
  count: number;
  last_edited: string; // "YYYY-MM-DD"
  created_by: {name: string; email: string};
}

class CohortsClient extends BaseClient {
  buildEndpoint({
    projectID,
    projectId,
    cohortID,
    workspaceId,
  }: {
    projectID?: number;
    projectId?: number;
    cohortID?: number;
    workspaceId?: number;
  }): string {
    const endpointBase = workspaceId
      ? `api/app/workspaces/${workspaceId}`
      : `api/app/projects/${projectID || projectId}`;
    let endpoint = `${endpointBase}/cohorts/`;
    if (cohortID) {
      endpoint = endpoint + `${cohortID}/`;
    }
    return endpoint;
  }

  buildRequestBody(params) {
    return JSON.stringify(params.cohort);
  }

  buildQueryParams({dataGroupId}) {
    if (dataGroupId) {
      return {data_group_id: dataGroupId};
    } else {
      return null;
    }
  }

  processResponse(response) {
    return response.results;
  }

  getCohorts(
    {projectID, workspaceId, dataGroupId}: {projectID?: number; workspaceId?: number; dataGroupId?: number},
    queryOpts = {},
  ) {
    return this.query({projectID, workspaceId, dataGroupId}, queryOpts).then((results) => {
      return results.reduce((acc, serializedCohort) => {
        return {...acc, [serializedCohort.id]: Cohort.parseCohort(serializedCohort)};
      }, {});
    });
  }

  async createCohort({
    projectID,
    cohort,
    workspaceId,
  }: {
    projectID?: number;
    workspaceId?: number;
    cohort: CohortParams;
  }): Promise<CohortResponse> {
    return await apiClient.post(`${apiHost()}/${this.buildEndpoint({projectID, workspaceId})}`, cohort);
  }

  async deleteCohortById({
    projectID,
    cohortID,
    workspaceId,
  }: {
    projectID?: number;
    workspaceId?: number;
    cohortID: number;
  }): Promise<{id: number}> {
    return await apiClient.delete(`${apiHost()}/${this.buildEndpoint({projectID, cohortID, workspaceId})}`);
  }
}

export default new CohortsClient();
